import { supportedIcons } from './types';
export var menuItems = [{
  icon: supportedIcons.math,
  title: 'Solve a math equation',
  link: '/math-solver',
  logValue: 'math'
}, {
  icon: supportedIcons.writing,
  title: 'Check your paper',
  link: '/writing',
  logValue: 'writing'
}, {
  icon: supportedIcons.study,
  title: 'Prepare for a tough exam',
  link: '/study/v2/practice',
  logValue: 'practice'
}, {
  icon: supportedIcons.prep,
  title: 'Study flashcards',
  link: '/flashcards',
  logValue: 'chegg prep'
}, {
  icon: supportedIcons.qna,
  title: 'Post a new question',
  link: '/study/qa',
  logValue: 'qna'
}, {
  icon: supportedIcons.tbs,
  title: 'Access TextBook Solutions',
  link: '/study/tbs',
  logValue: 'tbs'
}, {
  icon: supportedIcons.tutorsChat,
  title: 'Chat with a tutor',
  link: 'tutors/chat/request/',
  logValue: 'chat',
  isNew: true,
  isCSPLive: true
}];